<template>
    <Layout>
        <div class="container" slot="content">
            <img
                src="http://p0.meituan.net/scarlett/abaf487f8e6fa9d23276da9c1f08644446165.png"
                alt=""
            />
            <h1>404</h1>
            <h3>页面不存在</h3>
        </div>
    </Layout>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    created() {
    },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
}
img {
    margin: 0 auto;
    display: block;
}
</style>
